"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelParser = exports.FormModelWalker = exports.processFormModel = exports.compileStaticEnums = exports.parseModelSyntaxNodes = exports.composeFormModel = void 0;
const saxes_1 = require("saxes");
const wire_saxes_handlers_1 = require("../shared/wire-saxes-handlers");
const handler_1 = require("./handler");
const handler_source_map_1 = require("./handler-source-map");
var compose_1 = require("./compose");
Object.defineProperty(exports, "composeFormModel", { enumerable: true, get: function () { return compose_1.composeFormModel; } });
var parse_syntax_nodes_1 = require("./parse-syntax-nodes");
Object.defineProperty(exports, "parseModelSyntaxNodes", { enumerable: true, get: function () { return parse_syntax_nodes_1.parseModelSyntaxNodes; } });
var process_form_model_1 = require("./process-form-model");
Object.defineProperty(exports, "compileStaticEnums", { enumerable: true, get: function () { return process_form_model_1.compileStaticEnums; } });
Object.defineProperty(exports, "processFormModel", { enumerable: true, get: function () { return process_form_model_1.processFormModel; } });
var walker_1 = require("./walker");
Object.defineProperty(exports, "FormModelWalker", { enumerable: true, get: function () { return walker_1.FormModelWalker; } });
class ModelParser {
    parser;
    handler;
    sourceHandler;
    reporter;
    constructor({ reporter, includeSourceMap = false, }) {
        this.reporter = reporter;
        this.parser = new saxes_1.SaxesParser({ xmlns: false });
        this.parser.ENTITIES.amp = "&amp;";
        this.parser.ENTITIES.gt = "&gt;";
        this.parser.ENTITIES.lt = "&lt;";
        this.parser.ENTITIES.quot = "&quot;";
        this.parser.ENTITIES.apos = "&apos;";
        this.handler = new handler_1.FormModelHandler(reporter);
        this.sourceHandler = new handler_source_map_1.FormModelSourceHandler(reporter);
        const handlers = [this.handler];
        if (includeSourceMap) {
            handlers.push(this.sourceHandler);
        }
        (0, wire_saxes_handlers_1.wireSaxesHandlers)(this.parser, handlers);
    }
    write(chunk) {
        this.parser.write(chunk);
    }
    close() {
        if (!this.handler.ready) {
            throw new Error("Did not receive a FormModel");
        }
        this.parser.close();
    }
    get model() {
        return this.handler.model;
    }
    get source() {
        return this.sourceHandler.model;
    }
    get location() {
        return {
            line: this.parser.line,
            col: this.parser.columnIndex,
            start: this.parser.position,
            end: this.parser.position + 1,
        };
    }
}
exports.ModelParser = ModelParser;
//# sourceMappingURL=index.js.map